export default {
  inserted: function (el) {
    const elem = document.createElement('span')
    elem.classList.add('required-mark')
    elem.textContent = '*'
    el.appendChild(elem)
  }
}
